var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "90px",
    viewBox: "0 0 101 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.2923977%",
    x2: "97.2264094%",
    y2: "50.2923977%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.15163934%",
    y1: "52.238806%",
    x2: "101.639344%",
    y2: "52.238806%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.871348027%",
    y1: "50%",
    x2: "98.6673501%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.89646335%",
    y1: "52.238806%",
    x2: "97.6422348%",
    y2: "52.238806%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.8442623%",
    y1: "50.2487562%",
    x2: "97.6434426%",
    y2: "50.2487562%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.89646335%",
    y1: "48.2587065%",
    x2: "97.6422348%",
    y2: "48.2587065%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0644292157%",
    y1: "49.7322112%",
    x2: "99.960952%",
    y2: "49.7322112%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "26.2569846%",
    y1: "9.12431108%",
    x2: "75.6251421%",
    y2: "92.4678506%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.744,56.399952 C93.672,56.6464071 93.672,56.975014 93.592,57.2214691 C93.36,58.0512013 93.12,58.7905667 92.808,59.4559955 C92.736,59.7024506 92.656,59.866754 92.576,60.1132092 C91.248,62.8406458 89.144,65.0669571 86.568,66.3895995 C86.256,66.553903 85.944,66.7182064 85.712,66.8003581 C85.472,66.8825098 85.16,67.0550284 84.928,67.1371801 C82.664,67.9586971 80.168,68.2051523 77.592,67.6300903 C70.176,65.978841 65.416,58.2976565 66.9768,50.4521685 C68.536,42.6066805 75.8,37.5707809 83.208,39.2220302 C85.864,39.7970921 88.208,41.2018863 90.16,43.1899576 C93.28,46.5746079 94.688,51.6105075 93.744,56.399952 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-40.2%",
    y: "-24.1%",
    width: "180.4%",
    height: "175.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549   0 0 0 0 0.294117647   0 0 0 0 1  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.5589988%",
    y1: "22.5971821%",
    x2: "77.3937227%",
    y2: "67.7403292%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#657EFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.8208136%",
    y1: "83.5610509%",
    x2: "21.3507611%",
    y2: "21.6997339%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D1FF",
    offset: "1.13208%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resellers",
    transform: "translate(-611.000000, -865.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 35,
    transform: "translate(611.000000, 865.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8952,9.47489726 C15.92,9.12164492 16.4808,7.95509069 16.1472,6.87068816 C15.8144,5.78628564 14.7136,5.19479335 13.6888,5.54804569 C12.664,5.90129803 12.1032,7.05963709 12.436,8.14403962 C12.7696,9.22844214 13.8704,9.8281496 14.8952,9.47489726 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1544,2.73845733 C19.8512,2.50021738 20.2328,1.70334582 20.0064,0.972195636 C19.7792,0.232830277 19.0312,-0.169713085 18.3344,0.068526864 C17.6376,0.306766813 17.256,1.0954232 17.4824,1.83478855 C17.7088,2.57415391 18.4576,2.97669728 19.1544,2.73845733 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3272,47.2236064 C2.06,47.2236064 2.6536,46.5992534 2.6536,45.8188122 C2.6536,45.0465862 2.06,44.414018 1.3272,44.414018 C0.5944,44.414018 0,45.0465862 0,45.8188122 C0,46.5992534 0.5944,47.2236064 1.3272,47.2236064 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.808,33.339968 C95.016,32.1651986 95.104,30.1853425 94,28.9037759 C92.896,27.6222092 91.016,27.5318424 89.808,28.7066118 C88.6,29.873166 88.512,31.8612373 89.624,33.1345887 C90.728,34.4161554 92.6,34.5065222 93.808,33.339968 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.288,46.5663928 C89.288,56.3917369 86.168,65.5598673 80.936,72.8220782 C78.048,76.7900056 74.616,80.2568076 70.632,82.9842443 C64.2344,87.4368668 56.5072,90 48.2344,90 C25.6,90 7.1808,70.5957669 7.1808,46.5663928 C7.1808,22.6191703 25.5216,3.12457035 48.2344,3.12457035 C56.5072,3.12457035 64.156,5.68770359 70.632,10.1485413 C74.616,12.8759779 78.048,16.3427799 80.936,20.3024922 C86.168,27.6550699 89.288,36.7410487 89.288,46.5663928 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C1CAD6",
    fillRule: "nonzero",
    points: "71.96 23.1120805 18.4976 23.1120805 18.4976 30.7111134 71.96 30.7111134"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B3BFCF",
    fillRule: "nonzero",
    points: "71.96 27.0717928 18.4976 27.0717928 18.4976 25.0919367 71.96 18.9798497"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#D6DEE8",
    fillRule: "nonzero",
    points: "10.4584 25.5930621 10.4584 23.1120805 63.9224 23.1120805 63.9224 30.7111134 10.4584 30.7111134 10.4584 28.0658284"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero",
    points: "63.9224 24.5168747 10.4584 24.5168747 10.4584 27.0717928 63.9224 27.0717928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.256,24.9276333 L10.8488,24.9276333 C9.3656,24.9276333 8.1168,23.6049908 8.1168,22.0358932 L8.1168,8.74374707 C8.1168,7.17464948 9.3656,5.852007 10.8488,5.852007 L71.336,5.852007 C72.816,5.852007 74.072,7.17464948 74.072,8.74374707 L74.072,22.0358932 C73.992,23.6871425 72.816,24.9276333 71.256,24.9276333 Z",
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.844,5.852007 L62.7512,5.852007 C63.844,5.852007 64.7024,6.76389095 64.7024,7.91401484 L64.7024,22.9477771 C64.7024,24.1061162 63.844,25.009785 62.7512,25.009785 L10.068,25.009785 C8.976,25.009785 8.1168,24.1061162 8.1168,22.9477771 L8.1168,7.91401484 C8.1168,6.76389095 8.976,5.852007 10.068,5.852007 L11.3952,5.852007",
    id: "Path",
    fill: "#EDF1FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9192,12.8595476 C31.224,12.5391559 31.224,12.013385 30.9192,11.6929933 C30.6144,11.3726017 30.12,11.3726017 29.8152,11.6929933 C29.5104,12.013385 29.5104,12.5391559 29.8152,12.8595476 C30.12,13.1799392 30.6144,13.1799392 30.9192,12.8595476 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9304,16.490653 C31.2352,16.1702613 31.2352,15.6444904 30.9304,15.3240988 C30.6256,14.9954919 30.1312,14.9954919 29.8264,15.3240988 C29.5216,15.6444904 29.5216,16.1702613 29.8264,16.490653 C30.1312,16.8110447 30.6256,16.8110447 30.9304,16.490653 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8856,20.0560371 C31.1904,19.7356454 31.1904,19.2098745 30.8856,18.8894828 C30.5816,18.5690912 30.0872,18.5690912 29.7824,18.8894828 C29.4776,19.2098745 29.4776,19.7356454 29.7824,20.0560371 C30.0872,20.3846439 30.5816,20.3846439 30.8856,20.0560371 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3544,14.8311885 C34.6592,14.5025817 34.6592,13.9850259 34.3544,13.6564191 C34.0496,13.3360275 33.5552,13.3360275 33.2512,13.6564191 C32.9464,13.9850259 32.9464,14.5025817 33.2512,14.8311885 C33.5552,15.1515802 34.0496,15.1515802 34.3544,14.8311885 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3104,18.3965726 C34.6152,18.0761809 34.6152,17.55041 34.3104,17.2300184 C34.0056,16.9096267 33.5112,16.9096267 33.2064,17.2300184 C32.9016,17.55041 32.9016,18.0761809 33.2064,18.3965726 C33.5112,18.7169642 34.0056,18.7169642 34.3104,18.3965726 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7232,12.8924083 C38.028,12.5720166 38.028,12.0462457 37.7232,11.725854 C37.4184,11.4054624 36.924,11.4054624 36.6192,11.725854 C36.3144,12.0462457 36.3144,12.5720166 36.6192,12.8924083 C36.924,13.2210151 37.4184,13.2210151 37.7232,12.8924083 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7336,16.5235137 C38.0384,16.203122 38.0384,15.6773511 37.7336,15.3569594 C37.4288,15.0365678 36.9352,15.0365678 36.6304,15.3569594 C36.3256,15.6773511 36.3256,16.203122 36.6304,16.5235137 C36.9352,16.8439053 37.4288,16.8439053 37.7336,16.5235137 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1512,20.3024922 C37.5824,20.3024922 37.932,19.9328095 37.932,19.4809751 C37.932,19.0209256 37.5824,18.6512429 37.1512,18.6512429 C36.72,18.6512429 36.3704,19.0209256 36.3704,19.4809751 C36.3704,19.9328095 36.72,20.3024922 37.1512,20.3024922 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1584,14.8640492 C41.4632,14.5436576 41.4632,14.0178866 41.1584,13.697495 C40.8536,13.3688882 40.3592,13.3688882 40.0544,13.697495 C39.7496,14.0178866 39.7496,14.5436576 40.0544,14.8640492 C40.3592,15.1844409 40.8536,15.1844409 41.1584,14.8640492 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1144,18.4294333 C41.4192,18.1090416 41.4192,17.5832707 41.1144,17.262879 C40.8096,16.9424874 40.3152,16.9424874 40.0104,17.262879 C39.7056,17.5832707 39.7056,18.1090416 40.0104,18.4294333 C40.3152,18.7580401 40.8096,18.7580401 41.1144,18.4294333 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5816,12.8677627 C44.8864,12.5473711 44.8864,12.0298153 44.5816,11.7012085 C44.2776,11.3808169 43.7832,11.3808169 43.4784,11.7012085 C43.1736,12.0298153 43.1736,12.5473711 43.4784,12.8677627 C43.7832,13.1963696 44.2776,13.1963696 44.5816,12.8677627 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5928,16.4988682 C44.8976,16.1784765 44.8976,15.6527056 44.5928,15.3323139 C44.288,15.0119223 43.7944,15.0119223 43.4896,15.3323139 C43.1848,15.6527056 43.1848,16.1784765 43.4896,16.4988682 C43.7944,16.8192598 44.288,16.8192598 44.5928,16.4988682 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5488,20.0724674 C44.8536,19.7438606 44.8536,19.2263048 44.5488,18.9059132 C44.244,18.5773063 43.7496,18.5773063 43.4448,18.9059132 C43.14,19.2263048 43.14,19.7438606 43.4448,20.0724674 C43.7496,20.3928591 44.244,20.3928591 44.5488,20.0724674 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0176,14.8394037 C48.3224,14.519012 48.3224,13.9932411 48.0176,13.6728495 C47.7128,13.3524578 47.2184,13.3524578 46.9136,13.6728495 C46.6088,13.9932411 46.6088,14.519012 46.9136,14.8394037 C47.2184,15.1597954 47.7128,15.1597954 48.0176,14.8394037 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9736,18.4130029 C48.2784,18.0843961 48.2784,17.5668404 47.9736,17.2382335 C47.6688,16.9178419 47.1744,16.9178419 46.8696,17.2382335 C46.5648,17.5668404 46.5648,18.0843961 46.8696,18.4130029 C47.1744,18.7333946 47.6688,18.7333946 47.9736,18.4130029 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4408,12.8513324 C51.7456,12.5227256 51.7456,12.0051698 51.4408,11.676563 C51.136,11.3561713 50.6424,11.3561713 50.3376,11.676563 C50.0328,12.0051698 50.0328,12.5227256 50.3376,12.8513324 C50.6424,13.1717241 51.136,13.1717241 51.4408,12.8513324 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.452,16.4742227 C51.7568,16.153831 51.7568,15.6280601 51.452,15.3076684 C51.1472,14.9872768 50.6528,14.9872768 50.348,15.3076684 C50.0432,15.6280601 50.0432,16.153831 50.348,16.4742227 C50.6528,16.8028295 51.1472,16.8028295 51.452,16.4742227 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.408,20.0478219 C51.7128,19.7274302 51.7128,19.2016593 51.408,18.8812677 C51.1032,18.5526608 50.6088,18.5526608 50.304,18.8812677 C49.9992,19.2016593 49.9992,19.7274302 50.304,20.0478219 C50.6088,20.3682135 51.1032,20.3682135 51.408,20.0478219 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8216,14.8722644 C55.1264,14.5518727 55.1264,14.0261018 54.8216,13.7057101 C54.5168,13.3853185 54.0224,13.3853185 53.7176,13.7057101 C53.4128,14.0261018 53.4128,14.5518727 53.7176,14.8722644 C54.0224,15.192656 54.5168,15.192656 54.8216,14.8722644 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7776,18.4458636 C55.0824,18.125472 55.0824,17.599701 54.7776,17.2793094 C54.4728,16.9507026 53.9784,16.9507026 53.6736,17.2793094 C53.3688,17.599701 53.3688,18.125472 53.6736,18.4458636 C53.9784,18.7662553 54.4728,18.7662553 54.7776,18.4458636 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2448,12.8841931 C58.5496,12.5638014 58.5496,12.0380305 58.2448,11.7176388 C57.94,11.389032 57.4456,11.389032 57.1408,11.7176388 C56.836,12.0380305 56.836,12.5638014 57.1408,12.8841931 C57.4456,13.2045847 57.94,13.2045847 58.2448,12.8841931 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.256,16.5152985 C58.5608,16.1866917 58.5608,15.6691359 58.256,15.3405291 C57.9512,15.0201375 57.4568,15.0201375 57.152,15.3405291 C56.8472,15.6691359 56.8472,16.1866917 57.152,16.5152985 C57.4568,16.8356902 57.9512,16.8356902 58.256,16.5152985 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.212,20.0806826 C58.5168,19.7602909 58.5168,19.23452 58.212,18.9141283 C57.9072,18.5937367 57.4128,18.5937367 57.108,18.9141283 C56.8032,19.23452 56.8032,19.7602909 57.108,20.0806826 C57.4128,20.4010742 57.9072,20.4010742 58.212,20.0806826 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6192,16.2606282 C21.6192,18.2404843 20.2928,19.8095819 18.4976,20.1381888 C18.2632,20.2203405 18.1072,20.2203405 17.8728,20.2203405 C15.844,20.2203405 14.1272,18.4869395 14.1272,16.2606282 C14.1272,14.1082535 15.7656,12.2927008 17.8728,12.2927008 C18.1072,12.2927008 18.2632,12.2927008 18.4976,12.3748525 C20.2928,12.6213076 21.6192,14.2725569 21.6192,16.2606282 Z",
    id: "Path",
    fill: "#B3BFCF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C1CAD6",
    fillRule: "nonzero",
    points: "71.96 47.4700615 18.4976 47.4700615 18.4976 55.0690944 71.96 55.0690944"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B3BFCF",
    fillRule: "nonzero",
    points: "71.96 51.437989 18.4976 51.437989 18.4976 49.4581328 71.96 48.792704"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#D6DEE8",
    fillRule: "nonzero",
    points: "10.4584 49.9510431 10.4584 47.4700615 63.9224 47.4700615 63.9224 54.9869427 10.4584 54.9869427 10.4584 52.4238094"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero",
    points: "63.9224 48.5462489 10.4584 48.5462489 10.4584 51.437989 63.9224 51.437989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.256,49.2856142 L10.8488,49.2856142 C9.3656,49.2856142 8.1168,47.9711869 8.1168,46.4020893 L8.1168,33.1017281 C8.1168,31.5326305 9.3656,30.209988 10.8488,30.209988 L71.336,30.209988 C72.816,30.209988 74.072,31.5326305 74.072,33.1017281 L74.072,46.4020893 C73.992,47.9711869 72.816,49.2856142 71.256,49.2856142 Z",
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.844,30.209988 L62.7512,30.209988 C63.844,30.209988 64.7024,31.1218719 64.7024,32.280211 L64.7024,47.3057581 C64.7024,48.4640972 63.844,49.367766 62.7512,49.367766 L10.068,49.367766 C8.976,49.367766 8.1168,48.4640972 8.1168,47.3057581 L8.1168,32.1980593 C8.1168,31.0397202 8.976,30.1278363 10.068,30.1278363 L11.3952,30.1278363",
    id: "Path",
    fill: "#EDF1FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8832,37.1518072 C31.188,36.8314155 31.188,36.3056446 30.8832,35.985253 C30.5784,35.6648613 30.084,35.6648613 29.7792,35.985253 C29.4744,36.3056446 29.4744,36.8314155 29.7792,37.1518072 C30.084,37.4721988 30.5784,37.4721988 30.8832,37.1518072 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8944,40.7829126 C31.1992,40.462521 31.1992,39.93675 30.8944,39.6163584 C30.5896,39.2877516 30.0952,39.2877516 29.7904,39.6163584 C29.4856,39.93675 29.4856,40.462521 29.7904,40.7829126 C30.0952,41.1033043 30.5896,41.1033043 30.8944,40.7829126 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3608,44.6686883 C30.792,44.6686883 31.1416,44.2990057 31.1416,43.8389561 C31.1416,43.3789065 30.792,43.0092239 30.3608,43.0092239 C29.9296,43.0092239 29.5808,43.3789065 29.5808,43.8389561 C29.5808,44.2990057 29.9296,44.6686883 30.3608,44.6686883 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3184,39.1234481 C34.6232,38.7948413 34.6232,38.2772856 34.3184,37.9568939 C34.0136,37.6282871 33.52,37.6282871 33.2152,37.9568939 C32.9104,38.2772856 32.9104,38.7948413 33.2152,39.1234481 C33.52,39.4438398 34.0136,39.4438398 34.3184,39.1234481 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3296,42.7463384 C34.6344,42.4259467 34.6344,41.9001758 34.3296,41.5797842 C34.0248,41.2593925 33.5312,41.2593925 33.2264,41.5797842 C32.9216,41.9001758 32.9216,42.4259467 33.2264,42.7463384 C33.5312,43.0749452 34.0248,43.0749452 34.3296,42.7463384 Z",
    id: "Path",
    fill: "#2D5887",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6872,37.1846679 C37.992,36.8642762 37.992,36.3467205 37.6872,36.0181136 C37.3824,35.697722 36.888,35.697722 36.5832,36.0181136 C36.2784,36.3467205 36.2784,36.8642762 36.5832,37.1846679 C36.888,37.5132747 37.3824,37.5132747 37.6872,37.1846679 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6984,40.8157733 C38.0032,40.4953816 38.0032,39.9696107 37.6984,39.6492191 C37.3936,39.3288274 36.8992,39.3288274 36.5944,39.6492191 C36.2896,39.9696107 36.2896,40.4953816 36.5944,40.8157733 C36.8992,41.136165 37.3936,41.136165 37.6984,40.8157733 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7096,44.4468787 C38.0144,44.1264871 38.0144,43.6007162 37.7096,43.2803245 C37.4048,42.9517177 36.9104,42.9517177 36.6056,43.2803245 C36.3008,43.6007162 36.3008,44.1264871 36.6056,44.4468787 C36.9104,44.7672704 37.4048,44.7672704 37.7096,44.4468787 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1224,39.1563088 C41.4272,38.8359172 41.4272,38.3101463 41.1224,37.9897546 C40.8176,37.6693629 40.324,37.6693629 40.0192,37.9897546 C39.7144,38.3101463 39.7144,38.8359172 40.0192,39.1563088 C40.324,39.4767005 40.8176,39.4767005 41.1224,39.1563088 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1336,42.7874143 C41.4384,42.4588074 41.4384,41.9412517 41.1336,41.6126449 C40.8288,41.2922532 40.3352,41.2922532 40.0304,41.6126449 C39.7256,41.9412517 39.7256,42.4588074 40.0304,42.7874143 C40.3352,43.1078059 40.8288,43.1078059 41.1336,42.7874143 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5464,37.1682375 C44.8512,36.8396307 44.8512,36.322075 44.5464,35.9934681 C44.2416,35.6730765 43.7472,35.6730765 43.4424,35.9934681 C43.1376,36.322075 43.1376,36.8396307 43.4424,37.1682375 C43.7472,37.4886292 44.2416,37.4886292 44.5464,37.1682375 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5576,40.7911278 C44.8624,40.4707361 44.8624,39.9449652 44.5576,39.6245736 C44.2528,39.3041819 43.7584,39.3041819 43.4536,39.6245736 C43.1488,39.9449652 43.1488,40.4707361 43.4536,40.7911278 C43.7584,41.1197346 44.2528,41.1197346 44.5576,40.7911278 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.568,44.4222332 C44.8728,44.1018416 44.8728,43.5760706 44.568,43.255679 C44.2632,42.9352873 43.7696,42.9352873 43.4648,43.255679 C43.16,43.5760706 43.16,44.1018416 43.4648,44.4222332 C43.7696,44.7426249 44.2632,44.7426249 44.568,44.4222332 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9816,39.1316633 C48.2864,38.8112717 48.2864,38.2855007 47.9816,37.9651091 C47.6768,37.6447174 47.1832,37.6447174 46.8784,37.9651091 C46.5736,38.2855007 46.5736,38.8112717 46.8784,39.1316633 C47.1832,39.452055 47.6768,39.452055 47.9816,39.1316633 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9928,42.7627687 C48.2976,42.4423771 48.2976,41.9166062 47.9928,41.5962145 C47.688,41.2676077 47.1936,41.2676077 46.8888,41.5962145 C46.584,41.9166062 46.584,42.4423771 46.8888,42.7627687 C47.1936,43.0831604 47.688,43.0831604 47.9928,42.7627687 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.888,37.3982623 C51.3192,37.3982623 51.668,37.0285796 51.668,36.5685301 C51.668,36.1166957 51.3192,35.747013 50.888,35.747013 C50.4568,35.747013 50.1072,36.1166957 50.1072,36.5685301 C50.1072,37.0285796 50.4568,37.3982623 50.888,37.3982623 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.416,40.7664823 C51.7208,40.4460906 51.7208,39.9285349 51.416,39.599928 C51.1112,39.2795364 50.6176,39.2795364 50.3128,39.599928 C50.008,39.9285349 50.008,40.4460906 50.3128,40.7664823 C50.6176,41.0950891 51.1112,41.0950891 51.416,40.7664823 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4272,44.3975877 C51.732,44.0771961 51.732,43.5514251 51.4272,43.2310335 C51.1224,42.9106418 50.628,42.9106418 50.3232,43.2310335 C50.0184,43.5514251 50.0184,44.0771961 50.3232,44.3975877 C50.628,44.7179794 51.1224,44.7179794 51.4272,44.3975877 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7856,39.164524 C55.0904,38.8441323 55.0904,38.3183614 54.7856,37.9979698 C54.4808,37.6775781 53.9864,37.6775781 53.6816,37.9979698 C53.3768,38.3183614 53.3768,38.8441323 53.6816,39.164524 C53.9864,39.4931308 54.4808,39.4931308 54.7856,39.164524 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7968,42.7956294 C55.1016,42.4752378 55.1016,41.9494669 54.7968,41.6290752 C54.492,41.3086835 53.9976,41.3086835 53.6928,41.6290752 C53.388,41.9494669 53.388,42.4752378 53.6928,42.7956294 C53.9976,43.1160211 54.492,43.1160211 54.7968,42.7956294 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2088,37.1764527 C58.5136,36.856061 58.5136,36.3302901 58.2088,36.0098985 C57.904,35.6895068 57.4104,35.6895068 57.1056,36.0098985 C56.8008,36.3302901 56.8008,36.856061 57.1056,37.1764527 C57.4104,37.4968444 57.904,37.4968444 58.2088,37.1764527 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.22,40.8075581 C58.5248,40.4789513 58.5248,39.9613956 58.22,39.6410039 C57.9152,39.3123971 57.4208,39.3123971 57.116,39.6410039 C56.8112,39.9613956 56.8112,40.4789513 57.116,40.8075581 C57.4208,41.1279498 57.9152,41.1279498 58.22,40.8075581 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2312,44.4304484 C58.536,44.1100567 58.536,43.5842858 58.2312,43.2638942 C57.9264,42.9435025 57.432,42.9435025 57.1272,43.2638942 C56.8224,43.5842858 56.8224,44.1100567 57.1272,44.4304484 C57.432,44.7590552 57.9264,44.7590552 58.2312,44.4304484 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6192,40.5364575 C21.6192,42.5163136 20.2928,44.0854112 18.4976,44.414018 C18.2632,44.4961698 18.1072,44.4961698 17.8728,44.4961698 C15.844,44.4961698 14.1272,42.7627687 14.1272,40.5364575 C14.1272,38.392298 15.7656,36.5685301 17.8728,36.5685301 C18.1072,36.5685301 18.2632,36.5685301 18.4976,36.6506818 C20.2928,36.9875038 21.6192,38.6387531 21.6192,40.5364575 Z",
    id: "Path",
    fill: "#B3BFCF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C1CAD6",
    fillRule: "nonzero",
    points: "71.96 71.754106 18.4976 71.754106 18.4976 79.3449237 71.96 79.3449237"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B3BFCF",
    fillRule: "nonzero",
    points: "71.96 75.7138182 18.4976 75.7138182 18.4976 73.7339621 71.96 67.6218751"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#D6DEE8",
    fillRule: "nonzero",
    points: "10.4584 74.3090241 10.4584 71.754106 63.9224 71.754106 63.9224 79.3449237 10.4584 79.3449237 10.4584 76.7900056"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero",
    points: "63.9224 71.8362577 10.4584 71.8362577 10.4584 75.7138182 63.9224 75.7138182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.256,73.5696587 L10.8488,73.5696587 C9.3656,73.5696587 8.1168,72.2470162 8.1168,70.6779186 L8.1168,57.3857725 C8.1168,55.8166749 9.3656,54.4940324 10.8488,54.4940324 L71.336,54.4940324 C72.816,54.4940324 74.072,55.8166749 74.072,57.3857725 L74.072,70.6779186 C73.992,72.3291679 72.816,73.5696587 71.256,73.5696587 Z",
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.844,54.4940324 L62.7512,54.4940324 C63.844,54.4940324 64.7024,55.3977012 64.7024,56.5560403 L64.7024,71.5815874 C64.7024,72.7399265 63.844,73.6518104 62.7512,73.6518104 L10.068,73.6518104 C8.976,73.6518104 8.1168,72.7399265 8.1168,71.5815874 L8.1168,56.5560403 C8.1168,55.3977012 8.976,54.4940324 10.068,54.4940324 L11.3952,54.4940324",
    id: "Path",
    fill: "#EDF1FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9024,61.501573 C31.2072,61.1811814 31.2072,60.6636256 30.9024,60.3350188 C30.5976,60.0146271 30.104,60.0146271 29.7992,60.3350188 C29.4944,60.6636256 29.4944,61.1811814 29.7992,61.501573 C30.104,61.8301798 30.5976,61.8301798 30.9024,61.501573 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9136,65.1326784 C31.2184,64.8122868 31.2184,64.2865159 30.9136,63.9661242 C30.6088,63.6457325 30.1144,63.6457325 29.8096,63.9661242 C29.5048,64.2865159 29.5048,64.8122868 29.8096,65.1326784 C30.1144,65.4530701 30.6088,65.4530701 30.9136,65.1326784 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9248,68.7637839 C31.2296,68.4433922 31.2296,67.9176213 30.9248,67.5972296 C30.62,67.2686228 30.1256,67.2686228 29.8208,67.5972296 C29.516,67.9176213 29.516,68.4433922 29.8208,68.7637839 C30.1256,69.0841755 30.62,69.0841755 30.9248,68.7637839 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7952,63.7360994 C34.2264,63.7360994 34.576,63.3664167 34.576,62.9145824 C34.576,62.4545328 34.2264,62.0848501 33.7952,62.0848501 C33.364,62.0848501 33.0144,62.4545328 33.0144,62.9145824 C33.0144,63.3664167 33.364,63.7360994 33.7952,63.7360994 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3496,67.1043194 C34.6544,66.7757126 34.6544,66.2581568 34.3496,65.92955 C34.0448,65.6091583 33.5504,65.6091583 33.2456,65.92955 C32.9408,66.2581568 32.9408,66.7757126 33.2456,67.1043194 C33.5504,67.424711 34.0448,67.424711 34.3496,67.1043194 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7064,61.5426489 C38.0112,61.214042 38.0112,60.6964863 37.7064,60.3760946 C37.4016,60.0474878 36.9072,60.0474878 36.6024,60.3760946 C36.2976,60.6964863 36.2976,61.214042 36.6024,61.5426489 C36.9072,61.8630405 37.4016,61.8630405 37.7064,61.5426489 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7176,65.1655391 C38.0224,64.8451475 38.0224,64.3275917 37.7176,63.9989849 C37.4128,63.6785932 36.9184,63.6785932 36.6136,63.9989849 C36.3088,64.3275917 36.3088,64.8451475 36.6136,65.1655391 C36.9184,65.4941459 37.4128,65.4941459 37.7176,65.1655391 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7288,68.7966445 C38.0336,68.4762529 38.0336,67.950482 37.7288,67.6300903 C37.424,67.3096987 36.9296,67.3096987 36.6248,67.6300903 C36.32,67.950482 36.32,68.4762529 36.6248,68.7966445 C36.9296,69.1170362 37.424,69.1170362 37.7288,68.7966445 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1416,63.5060746 C41.4464,63.185683 41.4464,62.6599121 41.1416,62.3395204 C40.8368,62.0191288 40.3432,62.0191288 40.0384,62.3395204 C39.7336,62.6599121 39.7336,63.185683 40.0384,63.5060746 C40.3432,63.8264663 40.8368,63.8264663 41.1416,63.5060746 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1528,67.1371801 C41.4576,66.8167884 41.4576,66.2910175 41.1528,65.9706258 C40.848,65.642019 40.3544,65.642019 40.0496,65.9706258 C39.7448,66.2910175 39.7448,66.8167884 40.0496,67.1371801 C40.3544,67.4575717 40.848,67.4575717 41.1528,67.1371801 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5656,61.5180033 C44.8704,61.1976117 44.8704,60.6718408 44.5656,60.3514491 C44.2608,60.0228423 43.7664,60.0228423 43.4616,60.3514491 C43.1568,60.6718408 43.1568,61.1976117 43.4616,61.5180033 C43.7664,61.838395 44.2608,61.838395 44.5656,61.5180033 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5768,65.1491088 C44.8816,64.8205019 44.8816,64.3029462 44.5768,63.9743394 C44.272,63.6539477 43.7776,63.6539477 43.4728,63.9743394 C43.168,64.3029462 43.168,64.8205019 43.4728,65.1491088 C43.7776,65.4695004 44.272,65.4695004 44.5768,65.1491088 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.588,68.771999 C44.8928,68.4516074 44.8928,67.9258365 44.588,67.6054448 C44.2832,67.2850531 43.7888,67.2850531 43.484,67.6054448 C43.1792,67.9258365 43.1792,68.4516074 43.484,68.771999 C43.7888,69.0923907 44.2832,69.0923907 44.588,68.771999 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0008,63.4814291 C48.3056,63.1610375 48.3056,62.6352666 48.0008,62.3148749 C47.696,61.9944832 47.2024,61.9944832 46.8976,62.3148749 C46.5928,62.6352666 46.5928,63.1610375 46.8976,63.4814291 C47.2024,63.810036 47.696,63.810036 48.0008,63.4814291 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.012,67.1125346 C48.3168,66.7921429 48.3168,66.266372 48.012,65.9459803 C47.7072,65.6255887 47.2136,65.6255887 46.9088,65.9459803 C46.604,66.266372 46.604,66.7921429 46.9088,67.1125346 C47.2136,67.4329262 47.7072,67.4329262 48.012,67.1125346 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4248,61.4933578 C51.7296,61.1729662 51.7296,60.6471953 51.4248,60.3268036 C51.12,60.0064119 50.6256,60.0064119 50.3208,60.3268036 C50.016,60.6471953 50.016,61.1729662 50.3208,61.4933578 C50.6256,61.8137495 51.12,61.8137495 51.4248,61.4933578 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.436,65.1244633 C51.74,64.7958564 51.74,64.2783007 51.436,63.957909 C51.1312,63.6293022 50.6368,63.6293022 50.332,63.957909 C50.0272,64.2783007 50.0272,64.7958564 50.332,65.1244633 C50.6368,65.4448549 51.1312,65.4448549 51.436,65.1244633 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.888,69.0266693 C51.3192,69.0266693 51.668,68.6569866 51.668,68.1969371 C51.668,67.7451027 51.3192,67.37542 50.888,67.37542 C50.4568,67.37542 50.1072,67.7451027 50.1072,68.1969371 C50.1072,68.6569866 50.4568,69.0266693 50.888,69.0266693 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8048,63.522505 C55.1096,63.1938982 55.1096,62.6763424 54.8048,62.3477356 C54.5,62.0273439 54.0064,62.0273439 53.7016,62.3477356 C53.3968,62.6763424 53.3968,63.1938982 53.7016,63.522505 C54.0064,63.8428966 54.5,63.8428966 54.8048,63.522505 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.816,67.1453952 C55.1208,66.8250036 55.1208,66.2992327 54.816,65.978841 C54.5112,65.6584494 54.0168,65.6584494 53.712,65.978841 C53.4072,66.2992327 53.4072,66.8250036 53.712,67.1453952 C54.0168,67.4740021 54.5112,67.4740021 54.816,67.1453952 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.228,61.5262185 C58.5328,61.2058269 58.5328,60.6800559 58.228,60.3596643 C57.9232,60.0392726 57.4296,60.0392726 57.1248,60.3596643 C56.82,60.6800559 56.82,61.2058269 57.1248,61.5262185 C57.4296,61.8548253 57.9232,61.8548253 58.228,61.5262185 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2392,65.1573239 C58.544,64.8369323 58.544,64.3111614 58.2392,63.9907697 C57.9344,63.6703781 57.4408,63.6703781 57.136,63.9907697 C56.8312,64.3111614 56.8312,64.8369323 57.136,65.1573239 C57.4408,65.4777156 57.9344,65.4777156 58.2392,65.1573239 Z",
    id: "Path",
    fill: "#DFE8F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2504,68.7884294 C58.5552,68.4598225 58.5552,67.9422668 58.2504,67.61366 C57.9456,67.2932683 57.452,67.2932683 57.1472,67.61366 C56.8424,67.9422668 56.8424,68.4598225 57.1472,68.7884294 C57.452,69.108821 57.9456,69.108821 58.2504,68.7884294 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6192,64.8944385 C21.6192,66.8742946 20.2928,68.4433922 18.4976,68.7802142 C18.2632,68.8623659 18.1072,68.8623659 17.8728,68.8623659 C15.844,68.8623659 14.1272,67.1289649 14.1272,64.8944385 C14.1272,62.7502789 15.7656,60.9347262 17.8728,60.9347262 C18.1072,60.9347262 18.2632,60.9347262 18.4976,61.0168779 C20.2928,61.3454848 21.6192,62.9145824 21.6192,64.8944385 Z",
    id: "Path",
    fill: "#B3BFCF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6192,16.2606282 C21.6192,18.2404843 20.2928,19.8095819 18.4976,20.1381888 C16.7024,19.8095819 15.376,18.2404843 15.376,16.2606282 C15.376,14.2725569 16.7024,12.7034593 18.4976,12.3748525 C20.2928,12.6213076 21.6192,14.2725569 21.6192,16.2606282 Z",
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6192,40.5364575 C21.6192,42.5163136 20.2928,44.0854112 18.4976,44.414018 C16.7024,44.0854112 15.376,42.5163136 15.376,40.5364575 C15.376,38.5566014 16.7024,36.9875038 18.4976,36.6506818 C20.2928,36.9875038 21.6192,38.6387531 21.6192,40.5364575 Z",
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6192,64.8944385 C21.6192,66.8742946 20.2928,68.4433922 18.4976,68.7802142 C16.7024,68.4433922 15.376,66.8742946 15.376,64.8944385 C15.376,62.9145824 16.7024,61.3454848 18.4976,61.0168779 C20.2928,61.3454848 21.6192,62.9145824 21.6192,64.8944385 Z",
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.1856,
    y1: 79.8460491,
    x2: 96,
    y2: 79.8460491,
    id: "Path",
    stroke: "#D6DEE8",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.944,44.6686883 L75.944,76.3710319 C75.944,78.2769515 74.536,79.7638974 72.744,79.7638974 L38.244,79.7638974 C36.4488,79.7638974 35.044,78.2769515 35.044,76.3710319 L35.044,44.6686883 C35.044,42.7627687 36.4488,41.2758229 38.244,41.2758229 L72.744,41.2758229 C74.536,41.2758229 75.944,42.7627687 75.944,44.6686883 Z",
    id: "Path",
    fill: "#1C3754",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.624,44.6686883 L80.624,76.3710319 C80.624,78.2769515 79.216,79.7638974 77.424,79.7638974 L42.8488,79.7638974 C41.0536,79.7638974 39.6488,78.2769515 39.6488,76.3710319 L39.6488,44.6686883 C39.6488,42.7627687 41.0536,41.2758229 42.8488,41.2758229 L77.344,41.2758229 C79.144,41.2758229 80.624,42.7627687 80.624,44.6686883 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.624,44.6686883 L80.624,52.0130509 L39.6488,52.0130509 L39.6488,44.6686883 C39.6488,42.7627687 41.0536,41.2758229 42.8488,41.2758229 L77.344,41.2758229 C79.144,41.2758229 80.624,42.7627687 80.624,44.6686883 Z",
    id: "Path",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0784,62.9145824 L45.268,62.9145824 C44.488,62.9145824 43.7856,62.2573687 43.7856,61.3454848 L43.7856,58.371593 C43.7856,57.5500759 44.4096,56.8024954 45.268,56.8024954 L48.0784,56.8024954 C48.8584,56.8024954 49.5608,57.4679242 49.5608,58.371593 L49.5608,61.3454848 C49.5608,62.2573687 48.8584,62.9145824 48.0784,62.9145824 Z",
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0536,62.9145824 L54.244,62.9145824 C53.4632,62.9145824 52.7608,62.2573687 52.7608,61.3454848 L52.7608,58.371593 C52.7608,57.5500759 53.3856,56.8024954 54.244,56.8024954 L57.0536,56.8024954 C57.8344,56.8024954 58.5368,57.4679242 58.5368,58.371593 L58.5368,61.3454848 C58.5368,62.2573687 57.8344,62.9145824 57.0536,62.9145824 Z",
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0296,62.9145824 L63.2192,62.9145824 C62.4392,62.9145824 61.7368,62.2573687 61.7368,61.3454848 L61.7368,58.371593 C61.7368,57.5500759 62.3608,56.8024954 63.2192,56.8024954 L66.0296,56.8024954 C66.8096,56.8024954 67.512,57.4679242 67.512,58.371593 L67.512,61.3454848 C67.512,62.2573687 66.8096,62.9145824 66.0296,62.9145824 Z",
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.008,62.9145824 L72.192,62.9145824 C71.416,62.9145824 70.712,62.2573687 70.712,61.3454848 L70.712,58.371593 C70.712,57.5500759 71.336,56.8024954 72.192,56.8024954 L75.008,56.8024954 C75.784,56.8024954 76.488,57.4679242 76.488,58.371593 L76.488,61.3454848 C76.488,62.2573687 75.784,62.9145824 75.008,62.9145824 Z",
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0784,72.4113196 L45.268,72.4113196 C44.488,72.4113196 43.7856,71.754106 43.7856,70.842222 L43.7856,67.8683303 C43.7856,67.0468132 44.4096,66.2992327 45.268,66.2992327 L48.0784,66.2992327 C48.8584,66.2992327 49.5608,66.9646615 49.5608,67.8683303 L49.5608,70.842222 C49.5608,71.754106 48.8584,72.4113196 48.0784,72.4113196 Z",
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0536,72.4113196 L54.244,72.4113196 C53.4632,72.4113196 52.7608,71.754106 52.7608,70.842222 L52.7608,67.8683303 C52.7608,67.0468132 53.3856,66.2992327 54.244,66.2992327 L57.0536,66.2992327 C57.8344,66.2992327 58.5368,66.9646615 58.5368,67.8683303 L58.5368,70.842222 C58.5368,71.754106 57.8344,72.4113196 57.0536,72.4113196 Z",
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0296,72.4113196 L63.2192,72.4113196 C62.4392,72.4113196 61.7368,71.754106 61.7368,70.842222 L61.7368,67.8683303 C61.7368,67.0468132 62.3608,66.2992327 63.2192,66.2992327 L66.0296,66.2992327 C66.8096,66.2992327 67.512,66.9646615 67.512,67.8683303 L67.512,70.842222 C67.512,71.754106 66.8096,72.4113196 66.0296,72.4113196 Z",
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.008,72.4113196 L72.192,72.4113196 C71.416,72.4113196 70.712,71.754106 70.712,70.842222 L70.712,67.8683303 C70.712,67.0468132 71.336,66.2992327 72.192,66.2992327 L75.008,66.2992327 C75.784,66.2992327 76.488,66.9646615 76.488,67.8683303 L76.488,70.842222 C76.488,71.754106 75.784,72.4113196 75.008,72.4113196 Z",
    id: "Path",
    fill: "#C9D2DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero",
    points: "49.2488 37.3161106 47.0632 37.3161106 47.0632 45.7366605 49.2488 45.7366605"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero",
    points: "73.288 37.3161106 71.104 37.3161106 71.104 45.7366605 73.288 45.7366605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.624,74.0625689 L75.392,79.5913788 L75.32,79.6817457 L75.32,75.1387563 C75.32,74.4733275 75.784,73.9804172 76.408,73.9804172 L80.624,73.9804172 L80.624,74.0625689 Z",
    id: "Path",
    fill: "#DAE1ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.504,57.2132539 C93.272,58.0429862 93.032,58.7001998 92.72,59.4477803 C92.64,59.6942355 92.568,59.8585389 92.488,60.104994 C91.16,62.8324307 89.056,65.0587419 86.48,66.3813844 C86.168,66.5456878 85.856,66.7099912 85.544,66.7921429 C85.304,66.8742946 84.992,67.0468132 84.76,67.1289649 L76.328,58.1251379 L77.112,57.0489505 L73.368,52.9249348 L76.8,50.1974982 L81.016,48.0533386 L83.672,48.792704 L85.464,48.8748557 L93.504,57.2132539 Z",
    id: "Path",
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.936,46.6485445 C78.048,46.6485445 75.552,48.7105523 74.768,51.6844441 C73.832,51.6844441 73.68,51.6844441 73.52,51.9308992 C73.208,52.259506 73.208,52.6784797 73.52,53.0070866 L75.16,54.7404876 C75.472,55.0690944 75.864,55.0690944 76.176,54.7404876 L77.816,53.0070866 C78.128,52.6784797 78.128,52.259506 77.816,51.9308992 C77.656,51.7665958 77.504,51.6844441 77.344,51.6844441 C77.112,51.6844441 76.96,51.6844441 76.8,51.6844441 C77.656,49.2034625 80.312,47.9711869 82.656,48.8748557 C84.992,49.7867397 86.168,52.596328 85.304,55.0690944 C84.608,56.8846471 82.968,58.1251379 81.096,58.1251379 C79.84,58.1251379 78.672,57.6322276 77.816,56.638192 C77.424,56.2274334 76.88,56.2274334 76.488,56.638192 C76.096,57.0489505 76.096,57.6322276 76.488,58.0429862 C78.904,60.7704228 82.968,60.8525745 85.544,58.2894413 C88.12,55.726308 88.192,51.437989 85.776,48.7105523 C84.296,47.3879098 82.656,46.6485445 80.936,46.6485445 Z",
    id: "Path",
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.f7210e5c74f8865eca4aad59ab3354b6.svg";
export { ForwardRef as ReactComponent };